// The support form (go live, S1–S3): what people write to Hearth about, kept in the Support table
// and emailed to the operator.

export const SUPPORT_CATEGORIES = ['help', 'billing', 'broken', 'idea', 'complaint', 'privacy', 'abuse'] as const;
export type SupportCategory = (typeof SUPPORT_CATEGORIES)[number];

/** How the form names each (the canvas's support board, approved 2026-10-27). */
export const SUPPORT_CATEGORY_NAMES: Readonly<Record<SupportCategory, string>> = {
  help: 'Help with a server',
  billing: 'Billing',
  broken: "Something's broken",
  idea: 'An idea for Hearth',
  complaint: 'A complaint',
  privacy: 'My data and privacy',
  abuse: 'Report abuse',
};

export const SUPPORT_MESSAGE_MIN = 10;
export const SUPPORT_MESSAGE_MAX = 4000;
/** Messages one person may send in a day. */
export const SUPPORT_PER_DAY = 5;
/** How long a message is kept: the Privacy Policy says up to 2 years. */
export const SUPPORT_KEEP_DAYS = 730;

/** GSI on `Support`: `userId` + `createdAt` (keys only), for counting a person's messages in a day. */
export const SUPPORT_BY_USER_INDEX = 'byUser';

/** An item in the `Support` table: one message, with who sent it and where to reply. */
export interface SupportTicket {
  /** A ULID: sorts by when it was sent. */
  ticketId: string;
  userId: string;
  category: SupportCategory;
  /** The server it's about, if they picked one. */
  serverId?: string;
  message: string;
  createdAt: string; // ISO 8601 UTC
  /** Where to reply, and who to, as their account said when they wrote. */
  email?: string;
  name?: string;
  /** When DynamoDB's TTL removes it (epoch seconds): SUPPORT_KEEP_DAYS after it was sent. */
  expiresAtEpoch: number;
}
